module.exports = "/images/offer.png?7366e79422ab42704655549c9350edd3";